import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import classNames from "classnames";

import { Manager, Target, Popper } from "react-popper";
import Add from "../../../Icons/Add";
import Search from "../../../Icons/Search";
import CompleteCircle from "../../../Icons/CompleteCircle";

import Button from "material-ui/Button";
import ClickAwayListener from "material-ui/utils/ClickAwayListener";
import Collapse from "material-ui/transitions/Collapse";
import Portal from "material-ui/Portal";
import Input from "material-ui/Input";
import { InputAdornment } from "material-ui/Input";
import { MenuItem, MenuList } from "material-ui/Menu";

const styles = () => ({
  addBtn: {
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    background: "#FFFFFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "13px",
    color: "#5A5B62",
    fontWeight: "bold",
    padding: "8px 15px",
    minWidth: "unset",
    minHeight: "unset",
    whiteSpace: "nowrap",
  },

  addBtnOpen: {
    border: "1px solid #9CC0FF",
    color: "#5593FF",
    background: "#F2F6FF",
  },

  addBtnClose: {
    border: "1px solid #E7E9EB",
    color: "#5A5B62",
  },

  dropdown: {
    width: "352px",
    marginTop: "8px",
    background: "#FFFFFF",
    border: "1px solid #D8DBDF",
    boxShadow: "0 4px 8px rgba(0,0,0,.12)",
    maxHeight: "300px",
    display: "flex",
    flexDirection: "column",
  },

  searchBox: {
    padding: "11px",
    background: "#F0F2F4",
    boxSizing: "border-box",
  },

  searchItems: {
    overflow: "scroll",
  },

  popperClose: {
    pointerEvents: "none",
  },

  searchRoot: {
    width: "100%",
    height: "48px",
    alignItems: "center",
    border: "1px solid #D8DBDF",
    borderRadius: "2px",
    background: "#FFFFFF",
    padding: "0px 5px 0px 15px",
    boxSizing: "border-box",
  },

  searchInput: {
    background: "#FFFFFF",
    border: "none",
    color: "#181819",
    fontSize: "15px",
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    padding: "10px 12px",
  },

  row: {
    padding: "9px 10px 9px 22px",
    borderTop: "1px solid #D8DBDF",
    borderBottom: "none",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  label: {
    fontSize: "13px",
  },
});

class AddButton extends React.Component {
  state = {
    open: false,
    keyword: "",
    filteredFields: [],
  };

  componentWillMount() {
    this.setState({
      filteredFields: this.props.fields,
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      filteredFields: this.handleFilterFields(this.state.keyword, nextProps),
    });
  }

  handleChange = (e) => {
    const keyword = e.target.value;
    this.setState({
      keyword: keyword,
      filteredFields: this.handleFilterFields(keyword, this.props),
    });
  };

  handleFilterFields = (keyword, props) => {
    if (keyword) {
      return props.fields.filter(
        (item) =>
          item.label.includes(keyword) ||
          item.name.toLowerCase().includes(keyword.toLowerCase())
      );
    } else {
      return props.fields;
    }
  };

  handleToggle = () => {
    if (this.props.onClick) this.props.onClick();
    this.setState({ open: !this.state.open });
  };

  handleClose = (event) => {
    if (this.target.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  handleSelectField = (field) => () => {
    let selectedFields = this.props.selectedFields;

    if (selectedFields.includes(field)) {
      selectedFields = selectedFields.delete(field);
    } else {
      selectedFields = selectedFields.add(field);
    }

    this.props.handleUpdateMapping(selectedFields);
  };

  render() {
    const { classes } = this.props;
    const { open, filteredFields } = this.state;

    return (
      <Manager>
        <Target>
          <div
            ref={(node) => {
              this.target = node;
            }}
          >
            <Button
              className={classNames(
                classes.addBtn,
                open ? classes.addBtnOpen : classes.addBtnClose
              )}
              onClick={this.handleToggle}
              color="primary"
            >
              <Add
                color={open ? "#5593FF" : "#71737B"}
                width={15}
                height={15}
                style={{ display: "block", marginRight: "4px" }}
              />
              追加
            </Button>
          </div>
        </Target>
        <Portal>
          <Popper
            placement="bottom-end"
            eventsEnabled={open}
            className={classNames({ [classes.popperClose]: !open })}
            style={{ zIndex: 1000 }}
          >
            <ClickAwayListener onClickAway={this.handleClose}>
              <Collapse
                in={open}
                id="menu-list-collapse"
                style={{ transformOrigin: "0 0 0" }}
              >
                <div className={classes.dropdown}>
                  <div className={classes.searchBox}>
                    <Input
                      id="search"
                      type="search"
                      placeholder="項目を検索"
                      value={this.state.keyword}
                      onChange={this.handleChange}
                      disableUnderline={true}
                      startAdornment={
                        <InputAdornment position="start" style={{ margin: 0 }}>
                          <Search color="#D8DBDF" />
                        </InputAdornment>
                      }
                      classes={{
                        root: classes.searchRoot,
                        input: classes.searchInput,
                      }}
                    />
                  </div>
                  <div className={classes.searchItems}>
                    <MenuList>
                      {filteredFields.map((field, i) => (
                        <MenuItem
                          className={classes.row}
                          key={i}
                          onClick={this.handleSelectField(field.name)}
                          style={
                            this.props.selectedFields.includes(field.name)
                              ? { background: "rgba(26,101,255,.05)" }
                              : {}
                          }
                        >
                          <span className={classes.label}>{field.label}</span>
                          <CompleteCircle
                            width={15}
                            height={15}
                            color={
                              this.props.selectedFields.includes(field.name)
                                ? "#5593FF"
                                : "#B1B3B9"
                            }
                          />
                        </MenuItem>
                      ))}
                    </MenuList>
                  </div>
                </div>
              </Collapse>
            </ClickAwayListener>
          </Popper>
        </Portal>
      </Manager>
    );
  }
}

AddButton.propTypes = {
  classes: PropTypes.object.isRequired,
  fields: PropTypes.array,
  selectedFields: PropTypes.object,
  handleUpdateMapping: PropTypes.func,
  onClick: PropTypes.func,
};

export default withStyles(styles)(AddButton);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/common/AddButton.jsx